// frontend/src/services/categoryService.js
import axios from 'axios';

const API_URL = '/api/tenant/categories'; // Endpoint creado en el backend

/**
 * Obtiene todas las categorías disponibles.
 * @returns {Promise<Array<object>>} - Promesa con un array de objetos { ID, NAME }.
 */
export const fetchCategories = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        throw error; // Propagar para manejo en el componente
    }
};

export const getCategoryById = async (categoryId) => {
    try {
        const response = await axios.get(`${API_URL}/${categoryId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching category ${categoryId}:`, error);
        throw error;
    }
};

export const createCategory = async (categoryData) => {
    try {
        const response = await axios.post(API_URL, categoryData);
        return response.data;
    } catch (error) {
        console.error('Error creating category:', error);
        throw error;
    }
};

export const updateCategory = async (categoryId, categoryData) => {
    try {
        const response = await axios.put(`${API_URL}/${categoryId}`, categoryData);
        return response.data;
    } catch (error) {
        console.error(`Error updating category ${categoryId}:`, error);
        throw error;
    }
};

export const deleteCategory = async (categoryId) => {
    try {
        const response = await axios.delete(`${API_URL}/${categoryId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting category ${categoryId}:`, error);
        throw error;
    }
};
